<!-- <div *ngIf="checkAbilitato && abilitato && !loading && recensioni && recensioni.length > 0"
    class="w-100 recensioni__wrapper">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner" role="listbox">
            <div class="recensione">
                <div class="titolo-recensione">
                    <div class="titolo-punteggio">
                        {{ getSlide().titolo }}
                        <app-punteggio-recensioni [media]="getSlide().valutazione"></app-punteggio-recensioni>
                    </div>
                    <div class="verificato">
                        <div class="flex__autore">
                            Di {{ getSlide().c_nome | titlecase }} {{ getSlide().c_cognome | titlecase }}
                            <span class="material-symbols-outlined">
                                verified_user
                            </span>
                        </div>
                        <div class="esperienza">
                            {{ getSlide().tv_nome }}
                        </div>
                    </div>
                </div>
                <div class="lis-dark testo-recensione" [ngClass]="!getSlide().mostraContenuto ? 'less' : 'more'">
                    {{getSlide().testo}}
                </div>
                <div class="sistema__wrapper">
                    <div class="sistema" *ngIf="getSlide().mostraDisponibile()">
                        <span class="sistema-label">
                            {{'generale.leggi' | translate}}
                        </span>
                        <span class="material-symbols-outlined sistema-span" (click)="getSlide().showContenuto()">
                            {{ !getSlide().mostraContenuto ? 'add' : 'remove'}}
                        </span>
                        <span class="sistema-label" *ngIf="!getSlide().mostraContenuto">
                            {{'generale.tutto' | translate }}
                        </span>
                        <span class="sistema-label" *ngIf="getSlide().mostraContenuto">
                            {{'generale.meno' | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="recensione" *ngIf="!fromMobile && recensioni && recensioni.length > 1">
                <div class="titolo-recensione">
                    <div class="titolo-punteggio">
                        {{ getSlideNext().titolo }}
                        <app-punteggio-recensioni [media]="getSlideNext().valutazione"></app-punteggio-recensioni>
                    </div>
                    <div class="verificato">
                        <div class="flex__autore">
                            Di {{ getSlideNext().c_nome | titlecase }} {{ getSlideNext().c_cognome | titlecase }}
                            <span class="material-symbols-outlined">
                                verified_user
                            </span>
                        </div>
                        <div class="esperienza">
                            {{ getSlideNext().tv_nome }}
                        </div>
                    </div>
                </div>
                <div class="lis-dark testo-recensione" [ngClass]="!getSlideNext().mostraContenuto ? 'less' : 'more'">
                    {{getSlideNext().testo}}
                </div>
                <div class="sistema__wrapper">
                    <div class="sistema" *ngIf="getSlideNext().mostraDisponibile()">
                        <span class="sistema-label">
                            {{'generale.leggi' | translate}}
                        </span>
                        <span class="material-symbols-outlined sistema-span" (click)="getSlideNext().showContenuto()">
                            {{ !getSlideNext().mostraContenuto ? 'add' : 'remove'}}
                        </span>
                        <span class="sistema-label" *ngIf="!getSlideNext().mostraContenuto">
                            {{'generale.tutto' | translate }}
                        </span>
                        <span class="sistema-label" *ngIf="getSlideNext().mostraContenuto">
                            {{'generale.meno' | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons__carousel" *ngIf="recensioni && recensioni.length > 1">
            <button (click)='getPrev()' class="btn__prev">
                <span class="material-symbols-outlined">
                    keyboard_double_arrow_left
                </span>
                Precedente
            </button>
            <button (click)='getNext()' class="btn__next">
                Successiva
                <span class="material-symbols-outlined">
                    keyboard_double_arrow_right
                </span>
            </button>
        </div>
    </div>
</div> -->
<div
  *ngIf="
    checkAbilitato &&
    abilitato &&
    !loading &&
    recensioni &&
    recensioni.length > 0
  "
  class="w-100"
  style="min-height: 600px"
>
  <div *ngFor="let item of paginatedItems; let last = last">
    <div class="recensione__header">
      <div class="recensione__title">
        {{ item.c_nome != null ? (item.c_nome | titlecase) : "Utente privato" }}
        {{ item.c_cognome != null ? (item.c_cognome | titlecase) : "" }}
      </div>
      <div class="recensione__stelle">
        <span
          class="material-symbols-outlined star"
          *ngFor="let star of stars"
          [ngClass]="star <= item.valutazione ? 'colored' : 'uncolored'"
        >
          star
        </span>
      </div>
    </div>
    <div class="recensione__subheader">
      {{ item.tv_nome }}
      <span class="recensione__data">
        {{ calcolaDifferenza(item.datarecensione) }}
      </span>
    </div>
    <div [innerHTML]="item.testo" class="recensione__text"></div>
    <hr class="divider" *ngIf="!last" />
  </div>

  <p-paginator
    [showFirstLastIcon]="false"
    [rows]="itemsPerPage"
    [totalRecords]="recensioni.length"
    [rowsPerPageOptions]="[5]"
    (onPageChange)="onPageChange($event)"
  >
  </p-paginator>
</div>
<app-caricamento *ngIf="loading"></app-caricamento>
